import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonModalComponent } from 'app/main/core/common/common-modal/common-modal.component';
import { planworkConfig } from 'app/planwork.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ClientipService } from './clientip.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  apiUrl: any;
  dialogRef: any;
  baseUrl: any;
  exceptionText = 'There are some exception error, Please contact to support team.';
  assetCoreSerivceUrl: any;
  constructor(
    public http: HttpClient,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private clientipService: ClientipService
  ) {
    this.apiUrl = planworkConfig;
    this.assetCoreSerivceUrl = this.apiUrl.baseUrl + this.apiUrl.AssetBaseUrl + 'Asset/';
    this.baseUrl=this.apiUrl.baseUrl;
  }
  //post
  postService(input, url): Observable<any> {
    input.IpAddress = this.clientipService.IPAddress;

    return this.http.post(this.apiUrl.baseUrl + url, input, {
      headers: this.createHttpHeaders(),
      observe: 'response'
    }).pipe(
      catchError(err => {
        this.spinner.hide();
        this.dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: this.exceptionText }
        });
          this.dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          window.location.reload(); // <-- Full window reload
        }
      });
        return throwError(err);
      })
    );
  }

  post(input, url): Observable<any> {
    input.IpAddress = this.clientipService.IPAddress;

    return this.http.post(this.apiUrl.baseUrl + url, input, {
      headers: this.createHttpHeaders(),
      observe: 'body'
    }).pipe(
      catchError(err => {
        this.spinner.hide();
        this.dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: this.exceptionText }
        });
          this.dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          window.location.reload(); // <-- Full window reload
        }
      });
        return throwError(err);
      })
    );
  }


  assetCoreSerivce(input, url): Observable<any> {
    input.IpAddress = this.clientipService.IPAddress;

    return this.http.post(this.assetCoreSerivceUrl + url, input, {
      headers: this.createHttpHeaders(),
      observe: 'response'
    }).pipe(
      catchError(err => {
        this.spinner.hide();
        this.dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: this.exceptionText }
        });
          this.dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          window.location.reload(); // <-- Full window reload
        }
      });
        return throwError(err);
      })
    );
  }
  //post
  postSimpleService(input, url): Observable<any> {

    return this.http.post(this.apiUrl.baseUrl + url, input, {
      headers: this.createHttpHeaders(),
      observe: 'response'
    }).pipe(
      catchError(err => {
        this.spinner.hide();
        this.dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: this.exceptionText }
        });
          this.dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          window.location.reload(); // <-- Full window reload
        }
      });
        return throwError(err);
      })
    );
  }
  createHttpHeaders(): HttpHeaders {
    const currentToken = localStorage.getItem('token');
    const sbuid = localStorage.getItem('SbuId');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + currentToken,
      SbuId: sbuid ? sbuid : '0'
    });
  }
    postTableAPI<T>(currentUrl: any, params: any, ExtraHeaders: any): Observable<any> {
    console.log('ExtraHeaders: ', ExtraHeaders);
    let headers = this.getHeaders();
    if (ExtraHeaders && ExtraHeaders.headers) {
      // Merge custom headers with default headers
      Object.keys(ExtraHeaders.headers).forEach(key => {
        headers = headers.set(key, ExtraHeaders.headers[key]);
      });
    }
    return this.http.post<T>(currentUrl, params, {
      headers: headers,
    });
  }
    get(currentUrl: any): Observable<any> {
    return this.http.get(this.baseUrl + currentUrl,
      {
        headers: this.getHeaders(),
        observe: 'body'
      });
  }
    getHeaders(): HttpHeaders {
    const currentToken = localStorage.getItem('token');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + currentToken,
      'seperate-header': 'true'
    });
  }
    postAPI(saveData: any, currentUrl: any): Observable<any> {
    return this.http.post(this.baseUrl + currentUrl, saveData,
      {
        headers: this.getHeaders(),
        observe: 'response'
      });
  }

  delete(currentUrl: any): Observable<any> {
    return this.http.delete(this.baseUrl + currentUrl,
      {
        headers: this.getHeaders(),
        observe: 'body'
      });
  }
    postFormData(formData: FormData, currentUrl: string): Observable<any> {
    return this.http.post(this.baseUrl + currentUrl, formData, {
      headers: this.getformdataHeaders(),
      observe: 'body'
    });
  }
    getformdataHeaders(): HttpHeaders {
    const currentToken = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: 'Bearer ' + currentToken,
      'seperate-header': 'true'
    });
  }

  postPayroll(saveData: any, currentUrl: any): Observable<any> {
  // console.log('currentUrl: ', currentUrl);
    // console.log('saveData: ', saveData);
    return this.http.post(this.baseUrl + currentUrl, saveData,
      {
        headers: this.getHeaders(),
        observe: 'body'
      });

  }
}
